const ALLOWED = new Set(['routeKey', 'clubCode', 'cacheState', 'shellMs', 'cachedDataMs', 'cachedUsefulMs', 'usefulDataMs', 'freshUsefulMs', 'settledMs', 'requestCount', 'retryCount', 'timeoutCount', 'failedPanelCodes', 'slowestEndpointKey', 'slowestEndpointMs', 'imageReadyMs', 'accountState', 'facilitiesState', 'diningState', 'frontDeskState', 'clubNewsState'])
const clock = () => typeof performance !== 'undefined' ? performance.now() : Date.now()
const enabled = () => import.meta.env?.DEV !== false

export function emitRoutePerformance(detail = {}) {
  const safe = Object.fromEntries(Object.entries(detail).filter(([key]) => ALLOWED.has(key)))
  if (enabled()) console.info('[members-route-performance]', safe)
  return safe
}

export function createRouteVisit({ routeKey, clubCode, cacheState = 'miss', startedAt = clock() }) {
  const timings = {}; const counts = { requestCount: 0, retryCount: 0, timeoutCount: 0 }; const failed = new Set(); let emitted = false
  return {
    routeKey,
    mark(stage, at = clock()) { if (timings[stage] == null) timings[stage] = Math.max(0, Math.round(at - startedAt)); return timings[stage] },
    request({ retry = false, timeout = false, failedPanelCode } = {}) { counts.requestCount += 1; if (retry) counts.retryCount += 1; if (timeout) counts.timeoutCount += 1; if (failedPanelCode) failed.add(failedPanelCode) },
    settle(extra = {}) {
      if (emitted) return null
      emitted = true
      const settledMs = timings.settled ?? Math.max(0, Math.round(clock() - startedAt))
      return emitRoutePerformance({ routeKey, clubCode, cacheState, shellMs: timings.shell, cachedDataMs: timings.cached, usefulDataMs: timings.useful, settledMs, ...counts, failedPanelCodes: [...failed], ...extra })
    },
  }
}

export function routeTelemetryFields() { return [...ALLOWED] }
